export const campaignDetailsTranslations = {
    en: {
        // Tab Labels
        tabDetails: "Camp Details",
        tabOverview: "Camp Overview",
        tabBeneficiaries: "Beneficiaries",
        tabCoordinators: "Coordinators & Organizers",
        tabMedicine: "Medicine",
        tabEscalation: "Escalation",
        tabGallery: "Gallery",

        // Header & Actions
        acceptOrReject: "Accept or Reject",
        acceptOrRejectTitle: "Accept or reject campaign",
        updateStatus: "Update Campaign Status",
        preRegisterLink: "Pre-Register Link",
        copyLinkTooltip: "Copy Pre-Register Link",
        linkCopied: "Pre-registration link copied successfully",
        invalidUuid: "Invalid campaign UUID",
        fetchFailed: "Failed to fetch campaign details",

        // Labels
        campType: "Camp Type",
        startDateTime: "Camp Start Date & Time",
        endDateTime: "Camp End Date & Time",
        accepted: "Accepted",
        rejected: "Rejected",

        // Overview Section
        ageWiseCount: "Age-wise Beneficiaries Count",
        ageGroup: "Age Group",
        count: "Count",
        total: "Total",
        table: "Table",
        graph: "Graph",
        noDataChart: "No data available for the chart",

        noData: "No data available",
        loading: "Loading...",
        chart: "Chart",

        //coordindtors

        organizerList: "Organizer List",
        addOrganizer: "Add Organizer",
        addRemoveOrganizers: "Add / Remove Organizers",
        role: "Role",
        actions: "Actions",
        contact: "Contact",
        organizer: "Organizer",
        coordinator: "Co-ordinator",

        // Roles
        rugnamitra: "Rugnamitra",
        ngo: "NGO",
        hospital: "Hospital",
        pharmacy: "Pharmacy",
        bloodbank: "Blood Bank",
        dho: "DHO",
        tho: "THO",
        doctor: "Doctor",
        stemy: "Stemy",
        abha: "ABHA",
        mo: "MO",
        cmrf: "CMRF",
        mukhyamantri_hriday_sanjivani: "Mukhyamantri Hriday Sanjivani",
        
        //escaltion
        escalationActions: "Escalation Actions",
        takeAction: "Take Action",
        actionOn: "Action On",
        action: "Action",
        remark: "Remark",
        attachments: "Attachments",
        noRemark: "No remark provided",
        noActionsAvailable: "No Actions Available",
        noActionsRecorded: "No actions have been recorded for this campaign yet.",
        missingCampaignId: "Campaign ID is missing.",
        fetchActionsError: "Failed to fetch actions",

        //gallary

        mediaGallery: "Camp Media Gallery",
        uploadMedia: "Upload Media",
        noMediaFound: "Media Gallery",
        browseFiles: "Browse Files",
        dragDropText: "Drag & drop or click to upload images and videos",
        uploading: "Uploading...",
        uploadSuccess: "Media Uploaded Successfully",
        uploadFailed: "Some files failed to upload",
        selectFilesError: "Please select files to upload",
        fetchMediaError: "Failed to fetch campaign media",
        previewOf: "of",

        //camp pverview cahrts
        process: "Process",
        disease: "Disease",
        gender: "Gender",
        beneficiaryAnalysis: "Beneficiary Analysis",
        category: "Category",
        healthCampProcessOverview: "Health Camp Process Overview",
        diseaseDistribution: "Disease Distribution",
        genderDistribution: "Gender Distribution",

        // Process Steps Mapping
        pre_register: "Pre-Registration",
        register: "Counter Registration",
        doctor_screening: "Doctor Screening",
        blood_test: "HLL (Blood Test)",
        stemi: "Mukhyamantri Hriday Sanjivani",
        abha_card: "ABHA Card",
        scheme_refer: "Schemes Info",
        hospital_refer: "Referral Letter",
        total_beneficiary: "Total Beneficiary",

        //bene lsit
        pincode: "Pincode",
        district: "District",
        taluka: "Taluka",
        villageLocality: "Village/Locality",
        geographicalLocation: "Geographical Location",
        noRemarks: "No remarks yet.",
        allGenders: "All Genders",

        // Age Groups
        teenager: "13–17",
        young_adult: "18–35",
        adult: "36–55",
        senior_adult: "55+",
    },
    mr: {
        // Tab Labels
        tabDetails: "मोहीम तपशील",
        tabOverview: "मोहीम विहंगावलोकन",
        tabBeneficiaries: "लाभार्थी",
        tabCoordinators: "समन्वयक आणि आयोजक",
        tabMedicine: "औषध",
        tabEscalation: "एस्केलेशन",
        tabGallery: "गॅलरी",

        // Header & Actions
        acceptOrReject: "स्वीकारा किंवा नाकारा",
        acceptOrRejectTitle: "मोहीम स्वीकारा किंवा नाकारा",
        updateStatus: "मोहीम स्थिती अद्यतनित करा",
        preRegisterLink: "पूर्व-नोंदणी लिंक",
        copyLinkTooltip: "पूर्व-नोंदणी लिंक कॉपी करा",
        linkCopied: "पूर्व-नोंदणी लिंक यशस्वीरित्या कॉपी केली",
        invalidUuid: "अवैध मोहीम UUID",
        fetchFailed: "मोहीम तपशील मिळवण्यात अयशस्वी",

        // Labels
        campType: "मोहीम प्रकार",
        startDateTime: "मोहीम सुरू होण्याची वेळ",
        endDateTime: "मोहीम संपण्याची वेळ",
        accepted: "स्वीकारले",
        rejected: "नकारले",

        // Overview Section
        ageWiseCount: "वयोगटानुसार लाभार्थी संख्या",
        ageGroup: "वयोगट",
        count: "संख्या",
        total: "एकूण",
        table: "तक्ता",
        graph: "आलेख",
        noDataChart: "आलेखासाठी डेटा उपलब्ध नाही",

        noData: "डेटा उपलब्ध नाही",
        loading: "लोड होत आहे...",
        chart: "आलेख",

        organizerList: "आयोजक सूची",
        addOrganizer: "आयोजक जोडा",
        addRemoveOrganizers: "आयोजक जोडा / काढा",
        role: "भूमिका",
        actions: "कृती",
        contact: "संपर्क",
        organizer: "आयोजक",
        coordinator: "समन्वयक",

        // Roles
        rugnamitra: "रुग्णमित्र",
        ngo: "स्वयंसेवी संस्था (NGO)",
        hospital: "रुग्णालय",
        pharmacy: "फार्मसी",
        bloodbank: "रक्तपेढी",
        dho: "डी.एच.ओ. (DHO)",
        tho: "टी.एच.ओ. (THO)",
        doctor: "डॉक्टर",
        stemy: "स्टेमी",
        abha: "आभा (ABHA)",
        mo: "एम.ओ. (MO)",
        cmrf: "सी.एम.आर.एफ. (CMRF)",
        mukhyamantri_hriday_sanjivani: "मुख्यमंत्री हृदय संजीवनी",

        //escalation

        escalationActions: "एस्केलेशन कृती",
        takeAction: "कृती करा",
        actionOn: "यावर कृती",
        action: "कृती",
        remark: "शेरा",
        attachments: "जोडपत्रे",
        noRemark: "कोणताही शेरा दिलेला नाही",
        noActionsAvailable: "कोणतीही कृती उपलब्ध नाही",
        noActionsRecorded: "या मोहिमेसाठी अद्याप कोणत्याही कृतीची नोंद झालेली नाही.",
        missingCampaignId: "मोहीम आयडी गहाळ आहे.",
        fetchActionsError: "कृती मिळवण्यात अयशस्वी",

        //gallary 

        mediaGallery: "मोहीम मीडिया गॅलरी",
        uploadMedia: "मीडिया अपलोड करा",
        noMediaFound: "मीडिया गॅलरी",
        browseFiles: "फाईल्स निवडा",
        dragDropText: "इमेज आणि व्हिडिओ अपलोड करण्यासाठी ओढा आणि सोडा किंवा क्लिक करा",
        uploading: "अपलोड होत आहे...",
        uploadSuccess: "मीडिया यशस्वीरित्या अपलोड झाला",
        uploadFailed: "काही फाईल्स अपलोड करण्यात अयशस्वी",
        selectFilesError: "कृपया अपलोड करण्यासाठी फाईल्स निवडा",
        fetchMediaError: "मोहीम मीडिया मिळवण्यात अयशस्वी",
        previewOf: "पैकी",

        //overview cahrt 
        process: "प्रक्रिया",
        disease: "आजार",
        gender: "लिंग",
        beneficiaryAnalysis: "लाभार्थी विश्लेषण",
        category: "वर्ग",
        healthCampProcessOverview: "आरोग्य शिबिर प्रक्रिया विहंगावलोकन",
        diseaseDistribution: "आजार वितरण",
        genderDistribution: "लिंग वितरण",

        // Process Steps Mapping
        pre_register: "पूर्व-नोंदणी",
        register: "काऊंटर नोंदणी",
        doctor_screening: "डॉक्टर तपासणी",
        blood_test: "HLL (रक्त तपासणी)",
        stemi: "मुख्यमंत्री हृदय संजीवनी",
        abha_card: "आभा (ABHA) कार्ड",
        scheme_refer: "योजनांची माहिती",
        hospital_refer: "संदर्भ पत्र (Referral)",
        total_beneficiary: "एकूण लाभार्थी",

        //bene list 
        pincode: "पिनकोड",
        district: "जिल्हा",
        taluka: "तालुका",
        villageLocality: "गाव/परिसर",
        geographicalLocation: "भौगोलिक स्थान",
        noRemarks: "अद्याप कोणताही शेरा नाही.",
        allGenders: "सर्व लिंग",

        // Age Groups
        teenager: "१३–१७",
        young_adult: "१८–३५",
        adult: "३६–५५",
        senior_adult: "५५+",
    }
};